package top.wcpe.allincore.ui.runtime.event

import kotlin.jvm.JvmName

/**
 * 焦点变更事件。
 *
 * @property gainedFocus true 表示获得焦点，false 表示失去焦点
 */
data class FocusEvent(
    // 保留 Java 记录式访问器 ABI：消费方以 `event.gainedFocus()` 方法式调用
    @get:JvmName("gainedFocus") val gainedFocus: Boolean,
)
